import { $, media, merge } from "glamor";
import memoizeOne from "memoize-one";
import { theme } from "styles/theme";

// define breakpoint for element hide/collapsing
// 60 site nav, 549 min size main panel, 290 sort/filter dropdowns, 150 input
// NOTE: isMobileOrPhablet is used to hide elements as well
enum breakpoints {
    SEARCH_COLLAPSE = 1250,

    SELECT_COLLAPSE = 1700,

    CHIP_HIDE = 1050,
}

export const toolbarStyles = memoizeOne(() => {
    return merge(
        {
            alignItems: "center",
            display: "flex",
            height: "100%",
        },
        // collapse/expand search
        $(" .search__collapse", {
            [`@media (min-width:${breakpoints.SEARCH_COLLAPSE - 1}px)`]: {
                display: "none",
            },
        }),
        $(" .search__expand", {
            [`@media (max-width:${breakpoints.SEARCH_COLLAPSE}px)`]: {
                display: "none",
            },
        }),
        // hide/collapse/expand select-filter
        $(" .select__expand", {
            // break out of .sectionToolbarContent{overflow:hidden} that allows toolbar to shrink
            width: 270,
            height: 32,
            [`@media (max-width:${breakpoints.SELECT_COLLAPSE}px)`]: {
                display: "none",
            },
        }),
        $(" .select__collapse", {
            [`@media (min-width:${breakpoints.SELECT_COLLAPSE - 1}px)`]: {
                display: "none",
            },
        }),
        $(" .select__filter", {
            // break out of .sectionToolbarContent{overflow:hidden} that allows toolbar to shrink
            position: "absolute",
            [`@media (max-width:${breakpoints.CHIP_HIDE}px)`]: {
                display: "none",
            },
        }),
        // collapse/expand saved view label
        $(" .savedView", {
            overflow: "hidden",
            minWidth: 65,
            // maxWidth: 100,
            [`@media (max-width:${breakpoints.CHIP_HIDE}px)`]: {
                display: "none",
            },
        }),
        // collapse/expand clear filter label
        $(" .resetView", {
            marginLeft: 8,
            overflow: "hidden",
            minWidth: 65,
            [`@media (max-width:${breakpoints.CHIP_HIDE}px)`]: {
                display: "none",
            },
        }),
        $(" .spacer", {
            width: "1px",
            margin: "0 8px",
            background: theme.palette.borderColor,
            height: "18px",
        }),
        $(" .actions", {
            display: "flex",
            alignItems: "center",
            marginLeft: "auto",
            // shrink chipLabel
            overflow: "hidden",
            flex: "1 1",
            justifyContent: "flex-end",
        }),
        $(" .actions.inHistory > *", {
            display: "none",
        }),
        $(" .actions button svg", {
            color: theme.palette.darkGrey + " !important",
        }),
        $(" .actions button.deselected svg", {
            color: theme.palette.grey + " !important",
        }),
        $(" .sortIcon svg", {
            color: `${theme.palette.grey} !important`,
        }),
        $(" .MuiChip-root", {
            fontFamily: "Lato, sans-serif !important",
            fontSize: "11px !important",
            height: "24px !important",
        }),
        $(" .MuiChip-icon", {
            color: theme.palette.primary1Color,
        }),
        $(" .planButton.active svg path", {
            stroke: `${theme.palette.darkGrey} !important`,
        }),
        $(" .planButton.active svg circle", {
            stroke: `${theme.palette.darkGrey} !important`,
        }),
        $(" .chipLabel", {
            maxWidth: "150px",
            display: "block",
            position: "relative",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        }),
        media(
            "(max-width: 600px)",
            $(" .spacer", {
                display: "none",
            })
        )
    );
});

export const menuItemStyles = {
    selectedMenuItem: {
        color: theme.palette.primary1Color,
    },
    subMenuItem: {
        minWidth: 150,
    },
};

export const nestedViewButtonStyle = { display: "flex !important" };
